// Billing Add Credits Preview
export const BILLING_ADD_CREDITS_PREVIEW_REQUEST = 'BILLING_ADD_CREDITS_PREVIEW_REQUEST';
export const BILLING_ADD_CREDITS_PREVIEW_DONE = 'BILLING_ADD_CREDITS_PREVIEW_DONE';
export const BILLING_ADD_CREDITS_PREVIEW_FAILED = 'BILLING_ADD_CREDITS_PREVIEW_FAILED';
export const BILLING_ADD_CREDITS_PREVIEW_RESET = 'BILLING_ADD_CREDITS_PREVIEW_RESET';